import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Divider, Table, Drawer } from 'antd';
import H3Text from '@Uilib/h3Text';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import GrnActions from '@Actions/grnActions';
import { toISTDate } from '@Apis/constants';
import H3Modal from '@Uilib/H3Modal';
import UserActions from '@Actions/userActions';
import ViewPurchaseOrder from '../../Common/ViewPurchaseOrder';
import PurchaseFooter from '../../Common/PurchaseFooter';
import HideValue from '../../Common/RestrictedAccess/HideValue';
import PRZText from '../../Common/UI/PRZText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import MoreInfoMobileView from '../../Common/MoreInfoMobileView';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '../../../uilib/h3Image';
import './style.scss';
/**
 *
 */
class PendingPurchaseOrders extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      currentPage: 1,
      openPurchaseOrderModal: false,
      selectedRowKeys: [],
      selectedRows: [],
      productListColumns: [
        {
          title: '',
          render: (record) => (
            <div
             onClick={() => {
              // this.setState({ selectedPurchaseRequest: record, showPrModal: true });
            }}
            >
              <div
                // onClick={() => {
                //   this.setState({
                //     openPurchaseOrderModal: true, selectedPurchaseOrder: record, selectedRowKeys: [], selectedRows: [],
                //   });
                //   const { getPurchaseOrderById } = this.props;
                //   getPurchaseOrderById(record.po_id, record?.tenant_info?.tenant_id);
                // }}
                className="mobile-list__card"
              >
                <div
                  className="mobile-list__card_header"
                >
                  <div className="mobile-list__card_header-left">
                    <PRZText text={`#${record?.po_number}`} className="mobile-list__card_item-number" />
                  </div>
                </div>
                <div className="mobile-list__card_body">
                  <div className="mobile-list__card_body-left">
                    <div className="mobile-list__card_item-details">
                      {`Business Unit - ${record.tenant_info?.tenant_name}`}
                    </div>
                    <div className="mobile-list__card_item-details">
                      {`Items - ${record.no_of_items}`}
                    </div>
                    <PRZText text={`Delivery Date - ${toISTDate(record?.delivery_date).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />
                    <PRZText text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />
                  </div>
                </div>
                <Divider className="mobile-list__card_divider" />
                <div className="mobile-list__card_footer">
                  <div className="mobile-list__card_footer-right">
                    <PRZText
                      className="mobile-list__card__view-more_wrapper"
                      onClick={() => {
                        this.setState({ selectedPOForMobile: record, moreDetailsDrawer: true });
                      }}
                      text={(
                        <span className="mobile-list__card__view-more-text_wrapper">
                          <span className="mobile-list__card__view-more-text">More Info</span>
                          <FontAwesomeIcon
                            className="mobile-list__card__view-more-icon"
                            icon={faAnglesRight}
                          />
                        </span>
                      )}
                    />
                  </div>
                </div>
              </div>
              <Drawer
                open={this.state?.moreDetailsDrawer}
                width="420px"
                mask
                onClose={() => this.setState({ moreDetailsDrawer: false })}
                destroyOnClose
              >
                <div className="custom-drawer__header-wrapper">
                  <div
                    className="custom-drawer__header"
                    style={{ width: '370px' }}
                  >
                    <H3Text
                      text={`${this.state?.selectedPOForMobile?.po_number}`}
                      className="custom-drawer__title"
                    />
                    <H3Image
                      src={closeIcon}
                      className="custom-drawer__close-icon"
                      onClick={() => this.setState({ moreDetailsDrawer: false })}
                    />
                  </div>
                </div>
                <MoreInfoMobileView
                  description={this.state?.selectedPOForMobile?.description}
                  customFields={this.state?.selectedPOForMobile?.custom_fields}
                  fields={this.ListScreenKeys({ documentData: this.state?.selectedPOForMobile, isDataMaskingPolicyEnable: isDataMaskingPolicyEnable, isHideCostPrice: isHideCostPrice, })}
                />
              </Drawer>
            </div>
          ),
          responsive: ['xs'],
        },
        {
          title: 'PO NUMBER',
          render: (record) => (
            <div className="column-number__wrapper">
              {record?.po_number}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'BUSINESS UNIT',
          render: (text, record) => (
            <Fragment>
              <div className="associated-entity">
                {record.tenant_info?.tenant_name}
              </div>
            </Fragment>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'VENDOR',
          render: (text, record) => (
            <React.Fragment>
              <H3Text text={record?.seller_info?.internal_slr_code} className="org-pending-po__table-text" />
              <div
                className="associated-entity"
                onClick={() => window.open(`/vendors/view/${record?.seller_info?.seller_id}`)}
              >
                {record?.seller_info?.seller_name || ' - '}

              </div>
            </React.Fragment>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'ITEMS',
          render: (text, record) => (
            <div>
              {record.no_of_items}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'AMOUNT',
          render: (text, record) => (
            <div className="column-amount">
              {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view amount" /> : this.props.MONEY(((record?.document_po_grand_total || record?.po_grand_total || '0')), record?.org_currency_info?.currency_code)}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'CREATED DATE',
          render: (text, record) => (
            <div>
              <div className="column-date">
                {toISTDate(record?.po_date).format('DD/MM/YYYY')}
              </div>
              <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: '',
          key: 'action',
          render: (text, record) => (
            <div className="list__actions">
              <div
                className="list__actions-button list__actions-button-dark"
                onClick={() => {
                  this.setState({
                    openPurchaseOrderModal: true, selectedPurchaseOrder: record, selectedRowKeys: [], selectedRows: [],
                  });
                  const { getPurchaseOrderById } = this.props;
                  getPurchaseOrderById(record.po_id, record?.tenant_info?.tenant_id);
                }}
              >
                View
              </div>
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          className: 'list__actions-column',
        },
      ],
      mobilePendingPosLength: 3,
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { getPendingActions } = props;
      getPendingActions('map_po', 10, state.currentPage, () => {});
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @param {*} data
   * @return
   */
  getDataSource = (data) => {
    if (data) {
      const tempData = [];
      const operationData = data;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: operationData?.[i]?.po_id,
        });
      }
      return tempData;
    }
    return [];
  }

  ListScreenKeys = ({ documentData, isDataMaskingPolicyEnable, isHideCostPrice, }) => {
      const record = documentData;

      return [
        {
          label: 'PO NUMBER',
          value: record?.po_number,
        },
        {
          label: 'BUSINESS UNIT',
          value: record?.tenant_info?.tenant_name,
        },
        {
          label: 'VENDOR',
          value: record?.seller_info?.seller_name || '-',
        },
        {
          label: 'ITEM(S)',
          value: record?.no_of_items,
        },
        {
          label: 'AMOUNT',
          value: (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view amount" /> : this.props.MONEY(((record?.document_po_grand_total || record?.po_grand_total || '0')), record?.org_currency_info?.currency_code),
        },
        {
          label: 'CREATED DATE',
          value: `${toISTDate(record?.po_date).format('DD/MM/YYYY')} by ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'}`,
        },
      ];
    };

  /**
  * @param selectedRowKeys
  * @param selectedRows
  * @param record
  */
  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys, selectedRows,
    });
  };

  /**
  *
  * @return {JSX.Element}
  */
  render() {
    const {
        selectedPurchaseOrder,
        getPurchaseOrderByIdSuccess, getPurchaseOrderById,
        user, getGRN, updatePoStatusLoading, updatePoWorkflowStepLoading,
        pendingActions, getPendingActionsLoading, getPendingActions,
    } = this.props;
    const {
        openPurchaseOrderModal, productListColumns, currentPage, selectedRowKeys, selectedRows,
    } = this.state;
    return (
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      {`${Number(pendingActions?.po_approval_count)} Purchase Orders Pending On Your Approval`}
                    </div>
                  </div>
                )}
                bordered={false}
                loading={getPendingActionsLoading || updatePoStatusLoading || updatePoWorkflowStepLoading}
                showHeader
                size="small"
                scroll="scroll"
                columns={productListColumns}
                pagination={Number(pendingActions?.po_approval_count) > 10 ? {
                  defaultCurrent: 1,
                  current: currentPage,
                  total: Number(pendingActions?.po_approval_count),
                  pageSize: 10,
                  position: ['bottomLeft'],
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  showSizeChanger: false,
                  onChange: (page) => {
                    getPendingActions('map_po', 10, page, () => {});
                    this.setState({ currentPage: page });
                  },

                } : false}
                dataSource={this.getDataSource(pendingActions?.purchase_orders)}
                rowSelection={window.screen.width > 425 ? ({
                  selectedRowKeys,
                  onChange: this.onSelectChange,
                }) : false}
              />
            </div>
            <PurchaseFooter
              selectedRowKeys={selectedRowKeys}
              selectedRows={selectedRows}
              callback={() => {
                getPendingActions('map_po', 10, currentPage, () => {});
                this.setState({
                  selectedRows: [],
                  selectedRowKeys: [],
                });
              }}
            />
            <H3Modal
              onClose={() => {
                getPurchaseOrderByIdSuccess(null);
                this.setState({ openPurchaseOrderModal: false });
              }}
              className="pending-po__view-po"
              isOpen={openPurchaseOrderModal}
              title={`Purchase Order #${selectedPurchaseOrder ? selectedPurchaseOrder.po_number : ''} for ${selectedPurchaseOrder?.tenant_info?.tenant_name}`}
              showHeader
            >
              <ViewPurchaseOrder
                selectedPO={selectedPurchaseOrder}
                isUserReadyFromPendingScreen
                handleClose={() => {
                  getPurchaseOrderById(selectedPurchaseOrder?.po_id, selectedPurchaseOrder?.tenant_info?.tenant_id);
                  getPendingActions('map_po', 10, currentPage, () => {});
                  getGRN(user?.tenant_info?.tenant_id, null, selectedPurchaseOrder?.po_id, 'PURCHASE_ORDER', 'DRAFT,ISSUED', 10, 1, null);
                }}
                isQuickView
              />
            </H3Modal>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getPoPendingApprovalLoading: PurchaseOrderReducers.getPoPendingApprovalLoading,
  updatePoStatusLoading: PurchaseOrderReducers.updatePoStatusLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getPurchaseOrderByIdLoading: PurchaseOrderReducers.getPurchaseOrderByIdLoading,
  updatePoWorkflowStepLoading: PurchaseOrderReducers.updatePoWorkflowStepLoading,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getPurchaseOrderById: (poId, tenantId, callback) => dispatch(PurchaseOrderActions.getPurchaseOrderById(poId, tenantId, callback)),
  getPurchaseOrderByIdSuccess: (selectedPurchaseOrder) => dispatch(PurchaseOrderActions.getPurchaseOrderByIdSuccess(selectedPurchaseOrder)),
  getPendingActions: (actionType, limit, page, callback) => dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
  getGRN: (tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId) => dispatch(GrnActions.getGRN(tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId)),
});

PendingPurchaseOrders.propTypes = {
  getPoPendingApprovalLoading: PropTypes.bool,
  updatePoStatusLoading: PropTypes.bool,
  user: PropTypes.any,
  getPurchaseOrderById: PropTypes.func,
  history: PropTypes.func,
  selectedPurchaseOrder: PropTypes.any,
  getPurchaseOrderByIdSuccess: PropTypes.func,
  getGRN: PropTypes.func,
  updatePoWorkflowStepLoading: PropTypes.bool,
  getPendingActions: PropTypes.func,
  getPendingActionsLoading: PropTypes.bool,
  pendingActions: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PendingPurchaseOrders));
